import { render, staticRenderFns } from "./ClicCodeDiff.vue?vue&type=template&id=450328b8&"
import script from "./ClicCodeDiff.vue?vue&type=script&lang=js&"
export * from "./ClicCodeDiff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports